import { Pipe, PipeTransform } from '@angular/core';
import { notEmptyNullUndefined } from 'src/app/helpers/utils';
import { SKU } from 'src/app/models/data/sku.model';

@Pipe({
  name: 'displayAndCheckImage'
})
export class DisplayAndCheckImagePipe implements PipeTransform {

  transform(sku: SKU, ...args: unknown[]): string {
   return notEmptyNullUndefined(sku?.imagePath) ? `${sku.imagePath}` : 'assets\\img\\sku image\\defaultImg.png'
  }

}
